export const RYDESEND_WEB_URL = process.env.REACT_APP_SEND_API